import { Component, Inject } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Charge } from '../../../../models/entities/charge';
import { PaymentPlanComponent } from '../payment-plan/payment-plan.component';

export interface PaymentPlanDialogInput
{
    data: Charge[];
}

@Component({
    selector: 'payment-plan-dialog',
    styleUrls: ['./payment-plan-dialog.scss'],
    templateUrl: './payment-plan-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MatIconModule,
        MatButtonModule,
        PaymentPlanComponent,
    ],
})
export class PaymentPlanDialogComponent
{
    constructor(
           @Inject(MAT_DIALOG_DATA) public input: PaymentPlanDialogInput,
           private _dialogRef: MatDialogRef<PaymentPlanDialogComponent>,
    ) {
    }

    get paymentPlanCharges(): Charge[] {
        return this.input.data;
    }
    paymentPlanCreated() {
        this._dialogRef.close('paymentPlanCreated');
    }

    closeModal(): void {
        this._dialogRef.close();
    }
}
